import {
  mdiAccountGroupOutline,
  mdiBookOpenPageVariantOutline,
  mdiEmoticonOutline,
  mdiHomeOutline,
  mdiPackageVariant,
} from '@mdi/js'

/* eslint-disable */
// prettier-ignore
export default [
  { header: 'Pages' },

  { title: 'Dashboard', icon: mdiHomeOutline, to: 'dashboard' },
  { title: 'Clientes', icon: mdiEmoticonOutline, to: 'customer' },
  { title: 'Serviços', icon: mdiBookOpenPageVariantOutline, to: 'service' },
  { title: 'Produtos', icon: mdiPackageVariant, to: 'product' },
  { title: 'Fornecedores', icon: mdiBookOpenPageVariantOutline, to: 'supplier' },
  { title: 'Colaboradores', icon: mdiAccountGroupOutline, to: 'employee' },
]
